import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import NotificationItem from "./NotificationItem";
import { BellIcon } from "../../../svgFile";
import { useNotificationDropdown } from "../../common/hooks/useNotifications";

const NotificationDropdown = () => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const {
    notifications,
    unreadCount,
    isLoading,
    handleMarkAllAsRead,
    isMarkingAllAsRead
  } = useNotificationDropdown();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

   useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

    const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleViewAll = async (e) => {
    e.preventDefault();
    setIsOpen(false);
    navigate('/all-notification');
  };

  if (isLoading) {
    return (
      <div className="dropdown notification-dropdown" ref={dropdownRef}>
        <button
          ref={buttonRef}
          className="notification-btn dropdown-toggle"
          type="button"
          onClick={toggleDropdown}
          aria-expanded="false"
        >
          <BellIcon />
          <span className="notify-count">...</span>
        </button>
      </div>
    );
  }

  return (
    <div className="dropdown notification-dropdown" ref={dropdownRef}>
      <button
        ref={buttonRef}
        className="notification-btn dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
        onClick={toggleDropdown}
      >
        <BellIcon />
        <span className="notify-count">{unreadCount}</span>
      </button>
      <div className="dropdown-menu dropdown-menu-end p-0">
        <div className="d-flex justify-content-between align-items-center py-3 px-4 pb-2">
          <h3 className="mb-0 fw-semibold text-18">
            Notification
          </h3>
          <Link
            to="#"
            className="text-primary text-14"
            onClick={handleViewAll}
            style={{ opacity: isMarkingAllAsRead ? 0.6 : 1 }}
          >
            {isMarkingAllAsRead ? 'Marking...' : 'View All'}
          </Link>
        </div>
        <div className="notification-list pb-3">
          {notifications?.length === 0 ? (
            <div className="text-center py-4">
              <p className="mb-0 text-muted">No notifications</p>
            </div>
          ) : (
             notifications.map((item, i) => ( i < 5 &&
              <NotificationItem
                key={item?._id}
                item={item}
                isActive={!item?.isRead}
              />
            ))
          )}
        </div>
      </div>
    </div>
  )
}


export default NotificationDropdown;